import router from './router'
import store from './store'
import Vue from 'vue'
import { getToken } from './utils/token'


router.beforeEach((to, from, next) =>{
  if(to.meta.requireAuth && getToken() && to.meta?.roleAuth && store.state.user.dsUser){
      let auth = to.meta?.roleAuth
      let userType = store.state.user.dsUser.userType
      if(!auth.includes(userType)) {
        next(from.fullPath)
      }else {
        next()
      }
  }else {
    next()
  }
})

